var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"applicationTitle mb-0"},[_vm._v(_vm._s(_vm.clientName))]),_c('div',{staticClass:"applicationSubTitle"},[_vm._v(_vm._s(_vm.subTitle))]),_c('div',{staticClass:"font-weight-bold featuredFont"},[_vm._v(_vm._s(_vm.$g(_vm.title)))]),_c('div',{staticClass:"applicationDescription",domProps:{"innerHTML":_vm._s(_vm.desc)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }